module.exports = __webpack_public_path__ + "static/img/25.0766787f.jpg";